import { openInNewTab } from 'owa-attachment-user-operations';
import { ControlIcons } from 'owa-control-icons';
import { FilterableMenuItem } from 'owa-filterable-menu';
import loc from 'owa-localize';
import { OpenInNewTabText } from 'owa-locstrings/lib/strings/openinnewtabtext.locstring.json';
import { SxSStore } from 'owa-sxs-store';
import { PreviewPaneMode, WacPreviewState } from 'owa-sxsdata';
import logSxSCommandBarDatapoint from './logSxSCommandBarDatapoint';

export default function getOpenCloudyDocumentInNewTabButton(
    sxsStore: SxSStore
): FilterableMenuItem {
    const openInNewTabTextButton = new FilterableMenuItem(
        loc(OpenInNewTabText),
        ControlIcons.ReopenPages,
        () => {
            openInNewTab((sxsStore.viewState.previewPane as WacPreviewState).jsApiInfo.openUrl);
            logSxSCommandBarDatapoint('OpenInNewTab', {
                customData: { isLink: !sxsStore.extendedViewState.attachmentId },
            });
        },
        () =>
            sxsStore.extendedViewState.isCloudy &&
            sxsStore.viewState.previewPane &&
            sxsStore.viewState.previewPane.mode === PreviewPaneMode.Wac &&
            sxsStore.viewState.previewPane.jsApiInfo &&
            !!sxsStore.viewState.previewPane.jsApiInfo.openUrl
    );
    openInNewTabTextButton.ariaLabel = loc(OpenInNewTabText);
    return openInNewTabTextButton;
}
